const VALIDATION_ERROR_STATUS = 400;
const AUTHENTICATION_ERROR_STATUS = 401;
const PERMISSIONS_ERROR_STATUS = 403;
const DEFAULT_ERROR_STATUS = 500;

module.exports = {
  DEFAULT_ERROR_STATUS,
  AUTHENTICATION_ERROR_STATUS,
  PERMISSIONS_ERROR_STATUS,
  VALIDATION_ERROR_STATUS
};
